import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const InstallerContext = createContext(null);

export function InstallerProvider({ children }) {
  const { userProfile } = useAuth();
  const [installer, setInstaller] = useState({
    name: '',
    email: '',
    crewId: '',
    uid: ''
  });

  useEffect(() => {
    if (userProfile && userProfile.role === 'installer') {
      setInstaller({
        name: userProfile.name || userProfile.email || 'Installer',
        email: userProfile.email || '',
        crewId: userProfile.assignedCrew || '',
        uid: userProfile.id || userProfile.uid || ''
      });
    }
  }, [userProfile]);

  return (
    <InstallerContext.Provider value={installer}>
      {children}
    </InstallerContext.Provider>
  );
}

export function useInstaller() {
  const context = useContext(InstallerContext);
  if (context === null) {
    throw new Error('useInstaller must be used within InstallerProvider');
  }
  return context;
}